import { slugify } from "@/utils/slugify";
import { TextFieldProps } from "@/utils/types";
import { Label } from "./Label";
import { ChangeEvent } from "react";

interface TextareaProps extends TextFieldProps {
  onChangeArea?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Textarea = ({
  className,
  defaultValue,
  description,
  disabled,
  id,
  label,
  onChangeArea,
  placeholder,
  readOnly,
  required,
  hideLabel,
  value,
}: TextareaProps) => {
  const fieldId = `${label ? slugify(label) : "input"}_${id}`;
  const fieldArgs = {
    name: fieldId,
    id: fieldId,
    disabled,
    required,
    readOnly,
    value,
    defaultValue,
    placeholder,
  };
  return (
    <label
      className={`formField${className ? ` ${className}` : ""} textarea${
        disabled ? " disabled" : ""
      } w-full block`}
      htmlFor={fieldId}
    >
      <div>
        <Label
          label={label}
          description={description}
          className={hideLabel ? "hidden" : undefined}
        />
        <textarea
          {...fieldArgs}
          rows={4}
          onChange={onChangeArea}
          className="w-full rounded-[30px] py-3 px-6 resize-none bg-white"
        />
      </div>
    </label>
  );
};
